import PageLoadedQueue
    from "../../../../../../../Solutions.Neos.Site/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue";
import {Collapse} from "bootstrap";

export function searchResults(baseElement: HTMLElement) {
    const filter = baseElement.querySelector('.search-results-filter') as HTMLFormElement;
    const resultList = baseElement.querySelector('.search-result-list') as HTMLElement;
    const searchInput = baseElement.querySelector('#search-filter--search-term') as HTMLInputElement;

    if (!filter || !resultList) {
        return;
    }
    let controller = null;

    const collapseButton = baseElement.querySelector('[data-ss-toggle="collapse"][data-ss-target="#searchFilter"][aria-controls="searchFilter"]') as HTMLElement;
    if (collapseButton) {
        const collapseTarget = baseElement.querySelector(collapseButton.dataset.ssTarget) as HTMLElement;
        const collapse = Collapse.getOrCreateInstance(collapseTarget, {
            toggle: false
        });

        collapseButton.addEventListener('click', () => {
            collapse.toggle();
        });

        const collapseIndicator = collapseButton.querySelector('.collapse-indicator') as HTMLElement;
        collapseTarget.addEventListener('hide.bs.collapse', () => {
            collapseIndicator.classList.remove('rotate-180');
        });
        collapseTarget.addEventListener('hidden.bs.collapse', () => {
            collapseIndicator.classList.remove('rotate-180');
        });

        collapseTarget.addEventListener('show.bs.collapse', () => {
            collapseIndicator.classList.add('rotate-180');
        });
        collapseTarget.addEventListener('shown.bs.collapse', () => {
            collapseIndicator.classList.add('rotate-180');
        });
    }

    /**
     * Load the search results
     */
    const loadResults = (uri: URL) => {
        showLoading();

        requestSearchResults(uri.toString(), new FormData(filter))
            .then((response) => {
                if (response === '') {
                    showEmptyResults();
                    return;
                }

                resultList.innerHTML = response;

                // Add click event to pagination links
                const currentPage = filter.querySelector('input[name="page"]').getAttribute('value') || '1';
                const paginations = resultList.querySelectorAll('.pagination') as NodeListOf<HTMLElement>;
                paginations.forEach((pagination) => {
                    pagination.querySelectorAll(`button[value="${currentPage}"]`).forEach((button) => button.classList.add('active'));

                    const buttons = pagination.querySelectorAll('button') as NodeListOf<HTMLButtonElement>;
                    buttons.forEach((link) => {
                        link.addEventListener('click', (event) => {
                            event.preventDefault();

                            filter.querySelector('input[name="page"]').setAttribute('value', link.value);
                            filter.dispatchEvent(new Event('submit'));
                        });
                    });
                });
            })
    }

    /**
     * Request the search results from the server
     *
     * @param uri
     * @param formData
     */
    const requestSearchResults = async (uri: string, formData: FormData) => {
        if (controller) {
            controller.abort('Request cancelled due to new request.');
        }
        controller = new AbortController();

        formData.append('term', searchInput.value);

        const response = await fetch(uri, {
            method: 'POST',
            body: formData,
            signal: controller?.signal
        });


        if (!response.ok) {
            showError();
            throw new Error('Failed to fetch search results.');
        }

        return await response.text();
    }

    /**
     * Show the error template
     */
    const showError = () => {
        const template = baseElement.querySelector('.search-result-list--error') as HTMLTemplateElement;

        if (!template) {
            return;
        }

        resultList.innerHTML = template.innerHTML;
    }

    /**
     * Show the loading template
     */
    const showLoading = () => {
        const template = baseElement.querySelector('.search-result-list--loading') as HTMLTemplateElement;

        if (!template) {
            return;
        }

        resultList.innerHTML = template.innerHTML;
    }

    /**
     * Show the empty results template
     */
    const showEmptyResults = () => {
        const template = baseElement.querySelector('.search-result-list--empty') as HTMLTemplateElement;

        if (!template) {
            return;
        }

        resultList.innerHTML = template.innerHTML;
    }

    let uri = filter.getAttribute('action') || null;
    if (!uri) {
        showError();
        console.error('No action attribute found on form element for the search.');
        return;
    }
    const requestUri = new URL(uri, window.location.origin);

    // submit the form after a change
    filter.querySelectorAll('input, select').forEach((input) => {
        input.addEventListener('change', () => {
            filter.dispatchEvent(new Event('submit'));
        });
    });

    filter.addEventListener('submit', (event) => {
        event.preventDefault();

        // add form values as query to browser location url
        const formData = new FormData(filter);
        const searchParams = new URLSearchParams(location.search);

        // remove all searchFilter parameters
        searchParams.forEach((value, key) => {
            if (key.startsWith('searchFilter[')) {
                searchParams.delete(key);
            }
        });

        formData.forEach((value, key) => {
            if (key.startsWith('searchFilter[') && searchParams.has(key)) {
                searchParams.append(key, value as string);
            } else {
                searchParams.set(key, value as string);
            }
        });

        const url = new URL(location.href);
        url.search = searchParams.toString();

        window.history.pushState(null, '', `${url}`);

        loadResults(requestUri);
    });

    loadResults(requestUri);
}

const initSearchResultLists = () => {
    const lists = document.querySelectorAll('.search-result-wrapper');

    lists.forEach((list) => {
        searchResults(list as HTMLElement);
    });
}

PageLoadedQueue.addFunction(initSearchResultLists);
